import {
  DEPLOYMENT_SIZE_CONSUMERS,
  getDeploymentSizeLabel
} from './deploymentUtils';

export const CAPACITY_FILTER_KEYS = {
  size: 'consumers',
  engineVersion: 'engineVersions'
} as const;

export const getSizeFilterOptions = () =>
  DEPLOYMENT_SIZE_CONSUMERS.map(consumers => ({
    value: String(consumers),
    label: getDeploymentSizeLabel(consumers)
  }));

const releaseParts = (release: string) =>
  release.split('.').map(part => Number.parseInt(part, 10) || 0);

const compareNewestFirst = (a: string, b: string) => {
  const [partsA, partsB] = [releaseParts(a), releaseParts(b)];
  const length = Math.max(partsA.length, partsB.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (partsB[index] ?? -1) - (partsA[index] ?? -1);
    if (difference) return difference;
  }
  return 0;
};

export const sortReleasesNewestFirst = (releases: string[]) =>
  [...new Set(releases)].sort(compareNewestFirst);

export const asStringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.map(String) : [];

export const getCapacityFilterVariables = (
  filters: Record<string, unknown> | null | undefined
) => ({
  consumers: asStringList(filters?.[CAPACITY_FILTER_KEYS.size])
    .map(Number)
    .filter(Number.isInteger),
  engineVersions: asStringList(filters?.[CAPACITY_FILTER_KEYS.engineVersion])
});
